import { createContext, useContext } from 'react';

interface TableRowContextValue {
  href?: string;
}

export const TableRowContext = createContext<TableRowContextValue>({});

export const useTableRowContext = () => useContext(TableRowContext);
